import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { FullScreenNotificationLayout } from "@/layouts/FullScreenNotificationLayout/FullScreenNotificationLayout";
import { authenticatedRouting } from "@/modules/router/routings/authenticatedRouting";
import { FullScreenNotificationBox } from "@/modules/theme/components/FullScreenNotificationBox";
import { PageMeta } from "@/modules/theme/components/PageMeta";

import { ReactComponent as TestFailedIcon } from "./test-failed-icon.svg";

const translationNamespace = "pages/TestFailedPage";

export const TestFailedPage = () => {
  const { t } = useTranslation(translationNamespace);
  const history = useHistory();

  return (
    <FullScreenNotificationLayout
      onSubmit={() =>
        history.replace(authenticatedRouting.buildUrl("tutorials"))
      }
      variant="failed"
    >
      <PageMeta title={t("You haven't passed!")} />
      <FullScreenNotificationBox
        title={t("You haven't passed!")}
        text={t("Sorry, you haven't passed the test.")}
      >
        <TestFailedIcon />
      </FullScreenNotificationBox>
    </FullScreenNotificationLayout>
  );
};
